/**
 * i18next namespace paths — subset of oro-ui-toolkit NAMESPACES_ENUM
 * used by mobile readonly Oro forms. Values map to oro-locales folder paths.
 */
export const NAMESPACES_ENUM = {
  COMMON: 'toolkit/common',
  ANNOUNCEMENT: 'toolkit/oroforms/announcement',
  NEWUSERFORM: 'toolkit/oroforms/newUser',
  COMPANYINFOFORM: 'toolkit/oroforms/companyInfo',
  TICKETFORM: 'toolkit/oroforms/ticketForm',
  COMPANYINDINFO: 'toolkit/oroforms/companyIndInfo',
  DATAPRIVACY: 'toolkit/oroforms/dataPrivacy',
  UPDATESUPPLIERSTATUS: 'toolkit/oroforms/updateSupplierStatus',
  BANKINFO: 'toolkit/oroforms/bankInfo',
  CONTRACTFORM: 'toolkit/oroforms/contractForm',
  UPDATESUPPLIERCOMPANY: 'toolkit/oroforms/updateSupplierCompany',
  UPDATESUPPLIERSCOPE: 'toolkit/oroforms/updateSupplierScope',
  INVOICEFORM: 'toolkit/oroforms/invoiceForm',
  SANCTIONLISTFORM: 'toolkit/oroforms/sanctionList',
  SHAREHOLDERFORM: 'toolkit/oroforms/supplierShareHolder',
  OROITEMDETAILS: 'toolkit/oroforms/oroItemDetails',
  TEAMFORM: 'toolkit/oroforms/teamForm',
  SUPPLIERDETAILS: 'toolkit/oroforms/supplierDetails',
  SUPPLIERCALLBACK: 'toolkit/oroforms/supplierCallback',
  BASICINFO: 'toolkit/oroforms/basicInfo',
  COMPLIANCEFORMS: 'toolkit/oroforms/complianceForms',
  CATEGORYRECOMM: 'toolkit/oroforms/categoryRecommend',
  CATEGORYRECOMMV2: 'toolkit/oroforms/categoryRecommendV2',
  MATERIALRECOMMENDOR: 'toolkit/oroforms/materialRecommendor',
  SUPPLIEREDITOPTION: 'toolkit/oroforms/supplierEditOption',
  SUPPLIEREDITERP: 'toolkit/oroforms/supplierEditERP',
  APFORM: 'toolkit/oroforms/apForm',
  SUPPLIERINFORMATIONUPDATEFORM: 'toolkit/oroforms/supplierInformationUpdateForm',
  SUPPLIERPAYMENTTERM: 'toolkit/oroforms/supplierPaymentTerms',
  USEFORM: 'toolkit/oroforms/useForm',
  SUPPLIERFORM: 'toolkit/oroforms/supplierForm',
  SUPPLIERJUSTIFICATIONFORM: 'toolkit/oroforms/supplierJustification',
  SUPPLIERREQUESTVERIFICATIONFORM: 'toolkit/oroforms/supplierRequestVerfication',
  CHANGEPOFORM: 'toolkit/oroforms/changepoForm',
  RISKDATAVALIDATIONFORM: 'toolkit/oroforms/riskDataValidationForm',
  PROJECTFORM: 'toolkit/oroforms/projectForm',
  PURCHASEFORM: 'toolkit/oroforms/purchaseForm',
  PARTNERUSEFORM: 'toolkit/oroforms/partnerUseForm',
  QUOTESFORM: 'toolkit/oroforms/quotesForm',
  SUPPLIERATTRIBUTE: 'toolkit/oroforms/supplierAttribute',
  SUPPLIERIDENTIFICATIONV2: 'toolkit/oroforms/supplierIdentificationV2',
  SUPPLIER_PROPOSAL: 'toolkit/oroforms/supplierProposal',
  SUPPLIER_QUOTATION: 'toolkit/oroforms/supplierQuotation',
  SUPPLIER_CONTACT: 'toolkit/oroforms/supplierContact',
  KNOWLEDGE_MANAGEMENT: 'toolkit/oroforms/knowledgeManagement',
  SUPPLIER_CONTACT_STATUS: 'toolkit/oroforms/supplierContactStatusUpdate',
  ACCOUNT_ASSIGNMENT: 'toolkit/oroforms/accountAssignment',
  EXTERNAL_APPROVELS: 'toolkit/oroforms/externalApprovels',
  RFQ_REQUIREMENT_DETAILS: 'toolkit/oroforms/rfqRequirementDetails',
  RECEIPT_FORM: 'toolkit/oroforms/receiptForm',
  ORDER_CONFIRMATION_FORM: 'toolkit/oroforms/orderConfirmationForm',
  PURCHASE_CONFIRMATION_FORM: 'toolkit/oroforms/purchaseConfirmation',
  PO_OC_COMPARISON_FORM: 'toolkit/oroforms/poOcComparisonForm',
  ORDER_CONFIRMATION_PO_FORM: 'toolkit/oroforms/orderConfirmationPOForm',
  USER_PROFILE_CHANGE_FORM: 'toolkit/oroforms/userProfileChangeForm',
  MANAGE_USER_ACCESS_FORM: 'toolkit/oroforms/manageUserAccessForm',
  SUPPLIERTRANSACTIONALDETAILS: 'toolkit/oroforms/supplierTransactionalDetails',
  TRANSFER_OF_OWNERSHIP: 'toolkit/oroforms/transferOfOwnership',
  /** process-runner app-common — Executive Summary section copy. */
  APP_COMMON: 'process-runner/app-common',
} as const

export type NamespacesEnum = (typeof NAMESPACES_ENUM)[keyof typeof NAMESPACES_ENUM]
